import type { ImageLoaderProps } from "next/image";
import { toCdnAssetUrl } from "@trex-2b/libs/cdn";

const withSizeParams = (url: string, width: number, quality?: number) => {
  const searchParams = new URLSearchParams({
    w: String(width),
    q: String(quality ?? 75),
  });
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${searchParams.toString()}`;
};

export default function trexNextKitImageLoader({
  src,
  width,
  quality,
}: ImageLoaderProps) {
  const resolvedSrc = toCdnAssetUrl(src);
  return withSizeParams(resolvedSrc, width, quality);
}
